import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["deleted"];
  static values = { newSrc: String, editSrc: String, defaultKey: String };

  connect() {
    const chatKey = sessionStorage.getItem("massimo-chat-id") || this.defaultKeyValue;

    if (chatKey === "new" || chatKey === "history") {
      // The prompt stays in sessionStorage (chat_submit consumes it) — too long for the URL.
      const hasPrompt = Boolean(sessionStorage.getItem("massimo-prompt"));
      const autoSubmit = sessionStorage.getItem("massimo-autosubmit");
      sessionStorage.removeItem("massimo-autosubmit");
      const suggestionKey = sessionStorage.getItem("massimo-suggestion-key");
      sessionStorage.removeItem("massimo-suggestion-key");
      const source = sessionStorage.getItem("massimo-source");
      sessionStorage.removeItem("massimo-source");
      if (hasPrompt) {
        const url = new URL(this.newSrcValue, window.location.origin);
        url.searchParams.set("has_prompt", "1");
        if (autoSubmit) url.searchParams.set("autosubmit", "1");
        if (suggestionKey) url.searchParams.set("suggestion_key", suggestionKey);
        if (source) url.searchParams.set("source", source);
        this.element.src = url.toString();
      } else {
        this.element.src = this.newSrcValue;
      }
    } else if (chatKey) {
      // Restoring/defaulting the panel onto a chat must never mark it read — only clicking a history
      // row does (that link carries mark_read=1; see _history_item). #edit marks read only on that flag.
      this.element.src = this.editSrcValue.replace(":id", chatKey);
    }
  }

  deletedTargetConnected() {
    sessionStorage.setItem("massimo-chat-id", "new");
    this.element.src = this.newSrcValue;
  }
}
